import {Button, Divider, Stack} from '@mui/material';
import {AppointmentBookingEnum, FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {EmptySearchState} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {ChatRoomsEnum} from 'presentation/constants';
import {ChangeFlowVariantEnum} from 'presentation/modules/booking/shared/ui/components/ChangeFlowDialog/constants';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {useHealthDistrictNotFoundState} from './hooks/useHealthDistrictNotFoundState';
import {HealthDistrictNotFoundStateProps} from './types';

const {noResults, callToChat} = translations['pt-br'].commons;
const {goToUnit} = translations['pt-br'].privateFlow.bookingFlow.districtFlow.notFoundModal;

export function HealthDistrictNotFoundState({handleNextStep}: HealthDistrictNotFoundStateProps) {
	const {
		callChatRoom,
		callChatRoomIsLoading,
		handleChangeModals,
		hasTelehealth,
		description,
		changeLocationButtonLabel,
	} = useHealthDistrictNotFoundState();

	return (
		<EmptySearchState
			dataTagId={FinishWithoutCompleteFlowEnum.SEM_BAIRRO_DISPONIVEL}
			title={noResults}
			description={description}>
			<Stack gap={2}>
				{hasTelehealth ? (
					<Fragment>
						<Button variant="contained" size="large" onClick={handleNextStep}>
							{goToUnit}
						</Button>
						<Divider />
					</Fragment>
				) : null}
				<Button
					variant={hasTelehealth ? 'outlined' : 'contained'}
					size="large"
					data-tag-id={AppointmentBookingEnum.CLICK_ALTERAR_LOCAL_ATENDIMENTO_AGENDAMENTO}
					onClick={() => handleChangeModals(ChangeFlowVariantEnum.LOCATION)}>
					{changeLocationButtonLabel}
				</Button>
				<Button
					variant={'outlined'}
					size="large"
					data-tag-id={AppointmentBookingEnum.CLICK_FALAR_COM_ATENDIMENTO_AGENDAMENTO}
					onClick={async () => await callChatRoom(ChatRoomsEnum.APP)}
					disabled={callChatRoomIsLoading}
					endIcon={callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null}>
					{callToChat}
				</Button>
			</Stack>
		</EmptySearchState>
	);
}
